import React from 'react';
import { UpcomingCustomInterview } from '../../api/roundsApi';
import '../../styles/interview-extracted-info.css';

interface InterviewExtractedInfoContentProps {
  interview: UpcomingCustomInterview;
}

const InterviewExtractedInfoContent: React.FC<InterviewExtractedInfoContentProps> = ({
  interview,
}) => {
  const jd = interview.jdExtractedData;
  const addInfo = jd?.additional_info || {};
  const hasAddInfo = Object.values(addInfo).some((v) => v && v.trim());

  return (
    <div className="build-resume-jd-card">
      <div className="interview-info-card-header">
        <div className="info-cell name-cell">
          <span className="info-cell-label">Interview</span>
          <h3>{interview.name}</h3>
        </div>
        <div className="info-cell deadline-cell">
          <span className="info-cell-label">Deadline</span>
          <span className="info-cell-value">
            {new Date(interview.deadline).toLocaleDateString('en-US', {
              weekday: 'short',
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })}
          </span>
        </div>
        <div className="info-cell badges-cell">
          <span className={`interview-info-badge ${interview.accepted ? 'accepted' : 'pending'}`}>
            {interview.accepted ? 'Accepted' : 'Not Accepted'}
          </span>
          <span
            className={`interview-info-badge ${
              interview.jdProcessingStatus === 'processed' ? 'processed' : 'processing'
            }`}
          >
            {interview.jdProcessingStatus === 'processed' ? 'JD Processed' : 'JD Processing'}
          </span>
        </div>
      </div>

      {jd ? (
        <>
          <div className="jd-role-row">
            <span className="jd-role-name">{jd.role_name || 'Role'}</span>
            {(jd.company_name || jd.domain_name) && (
              <span className="jd-role-sub">
                {jd.company_name && <>at {jd.company_name}</>}
                {jd.company_name && jd.domain_name && ' — '}
                {jd.domain_name}
              </span>
            )}
          </div>

          <div className="jd-grid-row">
            <div className="jd-grid-col">
              <h4>Skills</h4>
              {jd.skills && jd.skills.length > 0 ? (
                <div className="jd-skill-list">
                  {jd.skills.map((s, i) => (
                    <span key={i} className="jd-skill">
                      {s}
                    </span>
                  ))}
                </div>
              ) : (
                <p className="jd-empty">No skills listed</p>
              )}
            </div>
            <div className="jd-grid-col">
              <h4>Qualifications</h4>
              {jd.qualifications && jd.qualifications.length > 0 ? (
                <ul className="jd-list">
                  {jd.qualifications.map((q, i) => (
                    <li key={i}>{q}</li>
                  ))}
                </ul>
              ) : (
                <p className="jd-empty">No qualifications listed</p>
              )}
            </div>
          </div>

          <div className="jd-grid-row">
            <div className="jd-grid-col">
              <h4>Responsibilities</h4>
              {jd.responsibilities && jd.responsibilities.length > 0 ? (
                <ul className="jd-list">
                  {jd.responsibilities.map((r, i) => (
                    <li key={i}>{r}</li>
                  ))}
                </ul>
              ) : (
                <p className="jd-empty">No responsibilities listed</p>
              )}
            </div>
            <div className="jd-grid-col">
              <h4>Additional Info</h4>
              {hasAddInfo ? (
                <div className="jd-kv-list">
                  {Object.entries(addInfo).map(([k, v]) =>
                    v && v.trim() ? (
                      <div key={k} className="jd-kv">
                        <span className="jd-kv-label">
                          {k.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())}
                        </span>
                        <span className="jd-kv-value">{v}</span>
                      </div>
                    ) : null
                  )}
                </div>
              ) : (
                <p className="jd-empty">None</p>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="interview-info-section">
          <h4>Job Description</h4>
          <p className="interview-info-jd">
            {interview.jobDescription || 'No job description provided.'}
          </p>
        </div>
      )}
    </div>
  );
};

export default InterviewExtractedInfoContent;
